export default __webpack_public_path__ + "static/media/img3.723e0f6a.png";